export default __webpack_public_path__ + "static/media/Keka.49e06c99.svg";